/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PromotionCheckingRequest } from './promotionCheckingRequest';
import { PromotionNotificationRequest } from './promotionNotificationRequest';
import { ConditionRequest } from './conditionRequest';
import { AwardStrategyRequest } from './awardStrategyRequest';


export interface PromotionRequest { 
    name: string;
    status?: PromotionRequest.StatusEnum;
    image?: string;
    description?: string;
    repeat: boolean;
    showOnHome?: boolean;
    rules?: string;
    validFrom?: string;
    validUntil?: string;
    loyaltyProgramId: number;
    placeInformationIds?: Array<number>;
    checker: PromotionCheckingRequest;
    conditions?: Array<ConditionRequest>;
    awardStrategies: Array<AwardStrategyRequest>;
    notificationRequest?: PromotionNotificationRequest;
}
export namespace PromotionRequest {
    export type StatusEnum = 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum
    };
}


